import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpUtilService } from 'src/app/core/services/http-util.service';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/app/core/constants/url.constants';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CustomInventoryLoginService {
  private loginData = new BehaviorSubject(null);
  loginData$ = this.loginData.asObservable();
 

  getLoginData(value): any {
    this.loginData.next(value);
  }

  // tslint:disable-next-line:member-ordering
  private userPwd = new BehaviorSubject(null);
  // tslint:disable-next-line:member-ordering
  userPwd$ = this.userPwd.asObservable();

  getUserPwd(value): any {
    this.userPwd.next(value);
  }


  constructor(private httpUtilService: HttpUtilService) { }

  checkUserCredentials(userId , pass): any {
    const data = {userid : userId , password : pass};
    return this.httpUtilService.post(Constants.CHECK_INVENTORY_USER_CREDENTIALS , data);
    // return this.httpUtilService.post(Constants.loginUser(userId , pass)
    // .CHECK_USER_CREDENTIALS , data);
  }

  /*validateCode(otp , userId , token): any {
   const body = {code : otp , uid : userId , vtoken : token};
   return this.httpUtilService.post(Constants.VALIDATE_CODE , body );
  // return this.httpUtilService.post(Constants.validateCode(otp , userId , token);
  //  .VALIDATE_CODE , body );
  }*/
  inventoryUpdatePassword(username,password,newpassword): Observable<any> {
    const requestParam = {
      userid: username,
      password: password,
      newpassword:newpassword
    };
    return this.httpUtilService.post(Constants.INVENTORY_UPDATE_PASSWORD, requestParam);
  }
}

